export default function Divider() {
  return <div className="border-t border-theme-separator pt-4 mt-6 sm:pt-8 sm:mt-10 w-full" />;
}
